import { CSSObject } from '@emotion/core';

import { RegisterByCodeParams } from '@api/auth/helpers';

export interface PhoneEmailInputProps {
    name?: string;
    value: string;
    onChange: (value: string) => void;
    error?: boolean;
    isLoading?: boolean;
    autoFocus?: boolean;
    theme?: 'primary' | 'secondary';
    iconClick?: () => void;
    /** @deprecated Emotion styling is no longer applied */
    iconCss?: CSSObject;
    /** @deprecated Emotion styling is no longer applied */
    css?: CSSObject;
    fieldType?: FieldType;
    disabled?: boolean;
    onClearError?: () => void;
    withoutLabel?: boolean;
}

export enum FieldType {
    PHONE = 'phone',
    EMAIL = 'email',
    AUTO = 'auto',
    CONTACT_PHONE = 'contact_phone',
    CONTACT_EMAIL = 'contact_email',
}

export interface SignInFormProps {
    logIn: (params: { phone: string; code: string }) => void;
    closeHandler: () => void;
    errorMessage: string;
    setPhone: (arg: string) => void;
    onChangeToRegistration: () => void;
    setEmail: (arg: string) => void;
    onChangeEmailToLogin: () => void;
    onChangePhoneToLogin: () => void;
    setIsLogin: (arg: boolean) => void;
    setErrorMessage: (arg: string) => void;
    path?: string;
    onStartTimer?: () => void;
    /** Submit уходит в Modal.confirmButtonText / handlerSubmit */
    hidePrimaryActions?: boolean;
    bindSubmit?: (submit: (() => Promise<void> | void) | null) => void;
}

export type RegisterParams = RegisterByCodeParams;

export interface BaseSendCodeProps {
    backToSignin: () => void;
    phone?: string;
    email?: string;
    errorMessage?: string;
    registerInfo?: any;
    setErrorMessage: (arg: string) => void;
    isLogin?: boolean;
    path?: string;
    startTimer?: () => void;
    stopTimer?: () => void;
    timeLeft?: number;
    isCanSendAgain?: boolean;
    hidePrimaryActions?: boolean;
    bindSubmit?: (submit: (() => Promise<void> | void) | null) => void;
}

export interface SendCodeByPhoneProps extends BaseSendCodeProps {
    register: (params: RegisterParams) => void;
    logIn: (params: { phone: string; code: string }) => void;
    setPhone: (arg: string) => void;
    sendCodeByEmailForRegistration?: (email: string) => Promise<void>;
}

export interface SendCodeByEmailProps extends BaseSendCodeProps {
    logIn: (params: { email: string; code: string }) => void;
    setEmail: (arg: string) => void;
    sendCodeByPhoneForRegistration?: (phone: string) => Promise<void>;
    register?: (params: RegisterParams) => void;
}

export interface RegisterFormProps {
    closeHandler: () => void;
    toggleForm: () => void;
    setPhone: (arg: string) => void;
    setEmail: (arg: string) => void;
    setRegisterInfo: (arg: any) => void;
    setIsLogin: (arg: boolean) => void;
    onChangeToSignIn: () => void;
    onChangePhoneToLogin: () => void;
    onChangeEmailToLogin: () => void;
    onStartTimer?: () => void;
    email?: string;
    phone?: string;
    hidePrimaryActions?: boolean;
    bindSubmit?: (submit: (() => Promise<void> | void) | null) => void;
}

export interface AuthPopupProps {
    isOpen: boolean;
    closeHandler: () => void;
    isRegistration?: boolean;
    redirectPath?: string;
}

export interface ResolveModalTitleParams {
    isCodeStep: boolean;
    isRegistrationForm: boolean;
    isSignIn: boolean;
}

export interface ResolveConfirmButtonTextParams {
    isLoading: boolean;
    isSignIn: boolean;
    isRegistrationForm: boolean;
    isCodeStep: boolean;
    isCanSendAgain: boolean;
}

export interface ResolveCloseButtonTextParams {
    isLoading: boolean;
    isRegistrationForm: boolean;
    isSendCodeByPhone: boolean;
    isSendCodeByEmail: boolean;
    isCanSendAgain: boolean;
    isLogin: boolean;
}
